import { baseURL } from './constant';
import { AppThunk } from './index';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU'
export const MENU_TOGGLE = '@customization/MENU_TOGGLE'
export const MENU_OPEN = '@customization/MENU_OPEN'
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY'
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS'
export const SET_LAYOUT = '@customization/SET_LAYOUT '
export const SET_DARKMODE = '@customization/SET_DARKMODE'

// action - canvas reducer
export const SET_DIRTY = '@canvas/SET_DIRTY'
export const REMOVE_DIRTY = '@canvas/REMOVE_DIRTY'
export const SET_CHATFLOW = '@canvas/SET_CHATFLOW'
export const SHOW_CANVAS_DIALOG = '@canvas/SHOW_CANVAS_DIALOG'
export const HIDE_CANVAS_DIALOG = '@canvas/HIDE_CANVAS_DIALOG'
export const SET_COMPONENT_NODES = '@canvas/SET_COMPONENT_NODES'
export const SET_COMPONENT_CREDENTIALS = '@canvas/SET_COMPONENT_CREDENTIALS'

// action - notifier reducer
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'

// action - dialog reducer
export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'


// action - agent reducer

export const FETCH_AGENTS_REQUEST = 'FETCH_AGENTS_REQUEST';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE';

export const ADD_AGENT_REQUEST = 'ADD_AGENT_REQUEST';
export const ADD_AGENT_SUCCESS = 'ADD_AGENT_SUCCESS';
export const ADD_AGENT_FAILURE = 'ADD_AGENT_FAILURE';

export const DELETE_AGENT_REQUEST = 'DELETE_AGENT_REQUEST';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const DELETE_AGENT_FAILURE = 'DELETE_AGENT_FAILURE';

// action - tool reducer

export const FETCH_TOOLS_REQUEST = 'FETCH_TOOLS_REQUEST';
export const FETCH_TOOLS_SUCCESS = 'FETCH_TOOLS_SUCCESS';
export const FETCH_TOOLS_FAILURE = 'FETCH_TOOLS_FAILURE';

export const ADD_TOOLS_REQUEST = 'ADD_TOOLS_REQUEST';
export const ADD_TOOLS_SUCCESS = 'ADD_TOOLS_SUCCESS';
export const ADD_TOOLS_FAILURE = 'ADD_TOOLS_FAILURE';


export const ADD_NODES_REQUEST = 'ADD_NODES_REQUEST';
export const ADD_NODES_SUCCESS = 'ADD_NODES_SUCCESS';
export const ADD_NODES_FAILURE = 'ADD_NODES_FAILURE';

export const EDIT_NODES_REQUEST = 'EDIT_NODES_REQUEST';
export const EDIT_NODES_SUCCESS = 'EDIT_NODES_SUCCESS';
export const EDIT_NODES_FAILURE = 'EDIT_NODES_FAILURE';


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';



// actionTypes.js
export const FETCH_KEY_KNOW_REQUEST = 'FETCH_KEY_KNOW_REQUEST';
export const FETCH_KEY_KNOW_SUCCESS = 'FETCH_KEY_KNOW_SUCCESS';
export const FETCH_KEY_KNOW_FAILURE = 'FETCH_KEY_KNOW_FAILURE';

export const ADD_KEY_KNOW_REQUEST = 'ADD_KEY_KNOW_REQUEST';
export const ADD_KEY_KNOW_SUCCESS = 'ADD_KEY_KNOW_SUCCESS';
export const ADD_KEY_KNOW_FAILURE = 'ADD_KEY_KNOW_FAILURE';

export const EDIT_KEY_KNOW_REQUEST = 'EDIT_KEY_KNOW_REQUEST';
export const EDIT_KEY_KNOW_SUCCESS = 'EDIT_KEY_KNOW_SUCCESS';
export const EDIT_KEY_KNOW_FAILURE = 'EDIT_KEY_KNOW_FAILURE';



export const enqueueSnackbar = (notification) => {
    const key = notification.options && notification.options.key

    return {
        type: ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random()
        }
    }
}

export const closeSnackbar = (key) => ({
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key
})


export const removeSnackbar = (key) => ({
    type: REMOVE_SNACKBAR,
    key
})

export const AgentsList = () => async (dispatch: any) => {
    dispatch({ type: FETCH_AGENTS_REQUEST });

    try {
        const response = await fetch(`${baseURL}/api/listAgents`);
        const data: any = await response.json() as { data: any, error?: string };

        if (response.ok) {
            dispatch({ type: FETCH_AGENTS_SUCCESS, payload: data?.data });
        } else {
            dispatch({ type: FETCH_AGENTS_FAILURE, error: data?.error });
        }
    } catch (error:any) {
        dispatch({ type: FETCH_AGENTS_FAILURE, error: error.message });
    }
};
export const AddAgent = (agentData: any) => async (dispatch) => {
    dispatch({ type: ADD_AGENT_REQUEST });
    console.log(agentData)

    try {
        const response = await fetch(`${baseURL}/api/addAgentFlow`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(agentData),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: ADD_AGENT_SUCCESS, payload: data });
        } else {
            dispatch({ type: ADD_AGENT_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: ADD_AGENT_FAILURE, error: error.message });
    }
};
export const deleteAgent = (id: number) => async (dispatch) => {
    dispatch({ type: DELETE_AGENT_REQUEST });

    try {
        const response = await fetch(`${baseURL}/api/delete-agent`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: DELETE_AGENT_SUCCESS, payload: id });
        } else {
            dispatch({ type: DELETE_AGENT_FAILURE, error: data.message });
        }
    } catch (error: any) {
        dispatch({ type: DELETE_AGENT_FAILURE, error: error.message });
    }
};

export const ToolsList = () => async (dispatch: any) => {
    dispatch({ type: FETCH_TOOLS_REQUEST });

    try {
        const response = await fetch(`${baseURL}/api/list-tools`);
        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: FETCH_TOOLS_SUCCESS, payload: data.data });
        } else {
            dispatch({ type: FETCH_TOOLS_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: FETCH_TOOLS_FAILURE, error: error.message });
    }
};
export const AddTools = (toolData: any) => async (dispatch) => {
    dispatch({ type: ADD_TOOLS_REQUEST });
    try {
        const response = await fetch(`${baseURL}/api/add-tools`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(toolData),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: ADD_TOOLS_SUCCESS, payload: data });
        } else {
            dispatch({ type: ADD_TOOLS_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: ADD_TOOLS_FAILURE, error: error.message });
    }
};

export const login = (username: string, password: string): AppThunk => 
    async (dispatch) => {
      dispatch({ type: LOGIN_REQUEST });
  
      try {
        const response = await fetch(`${baseURL}/api/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        });
  
        const data: any = await response.json();
  
        if (response.ok && data.token) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          dispatch({ type: LOGIN_SUCCESS, payload: data.user });
        } else {
          dispatch({
            type: LOGIN_FAILURE,
            error: data.error || 'Wrong username or password!',
          });
        }
      } catch (error: any) {
        dispatch({ type: LOGIN_FAILURE, error: error.message });
      }
    };

export const ListngKnowKeys = (user_id: number) => async (dispatch) => {
    dispatch({ type: FETCH_KEY_KNOW_REQUEST });

    try {
        const response = await fetch(`${baseURL}/api/get-know`, {
            method: 'POST', // Specify the HTTP method
            headers: {
                'Content-Type': 'application/json', // Inform the server that the request body is JSON
            },
            body: JSON.stringify({ user_id }), // Send user_id in the request body
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: FETCH_KEY_KNOW_SUCCESS, payload: data.data });
        } else {
            dispatch({ type: FETCH_KEY_KNOW_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: FETCH_KEY_KNOW_FAILURE, error: error.message });
    }
};


export const AddKnowledge = (knowledgeData: any) => async (dispatch) => {
    dispatch({ type: ADD_KEY_KNOW_REQUEST });
    try {
        const response = await fetch(`${baseURL}/api/key-know`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(knowledgeData),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: ADD_KEY_KNOW_SUCCESS, payload: data });
        } else {
            dispatch({ type: ADD_KEY_KNOW_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: ADD_KEY_KNOW_FAILURE, error: error.message });
    }
};

export const EditKnowledge = (knowledgeData: any) => async (dispatch) => {
    dispatch({ type: EDIT_KEY_KNOW_REQUEST });
    try {
        const response = await fetch(`${baseURL}/api/knowledge`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(knowledgeData),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: EDIT_KEY_KNOW_SUCCESS, payload: data });
        } else {
            dispatch({ type: EDIT_KEY_KNOW_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: EDIT_KEY_KNOW_FAILURE, error: error.message });
    }
};



export const AddNodes = (noteData: any) => async (dispatch) => {
    dispatch({ type: ADD_NODES_REQUEST });
    try {
        const response = await fetch(`${baseURL}/api/add-node`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(noteData),
        });

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: ADD_NODES_SUCCESS, payload: data });
        } else {
            dispatch({ type: ADD_NODES_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: ADD_NODES_FAILURE, error: error.message });
    }
};


export const EditNodes = (noteData: any) => async (dispatch) => {
    dispatch({ type: ADD_NODES_REQUEST });
    try {
        const response = await fetch(`${baseURL}/api/edit-node`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(noteData),
        });
        

        const data: any = await response.json();

        if (response.ok) {
            dispatch({ type: EDIT_NODES_SUCCESS, payload: data });
        } else {
            dispatch({ type: EDIT_NODES_FAILURE, error: data.error });
        }
    } catch (error: any) {
        dispatch({ type: EDIT_NODES_FAILURE, error: error.message });
    }
};